import { render, staticRenderFns } from "./OnlineReservationScheduleTab.vue?vue&type=template&id=784c8f6b&scoped=true&lang=pug"
import script from "./OnlineReservationScheduleTab.vue?vue&type=script&lang=ts"
export * from "./OnlineReservationScheduleTab.vue?vue&type=script&lang=ts"
import style0 from "./OnlineReservationScheduleTab.vue?vue&type=style&index=0&id=784c8f6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784c8f6b",
  null
  
)

export default component.exports